export * from "./WinningsDataModel";